import React from 'react'
import { Box, Flex } from 'reflexbox'
import isNode from 'is-node'

import { locales } from 'src/config'
import LinkComponent from 'src/components/LinkComponent/LinkComponent'
import MobileNav from 'src/components/MobileNav/MobileNav'
import Container from 'src/components/UI/Grid/Container'
import stores from 'src/stores/decorator'

import { Props } from './types'
import * as styles from './Header.module.scss'

@stores
class Header extends React.Component<Props> {
  previousScroll = 0
  headerElement = null

  constructor(props: Props) {
    super(props)
  }

  componentDidMount() {
    if (!isNode) {
      document.addEventListener('scroll', this.handleScroll)
    }
  }

  componentDidUpdate() {
    if (!isNode) {
      this.handleScroll()
    }
  }

  componentWillUnmount() {
    if (!isNode) {
      document.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll = () => {
    if (!isNode) {
      const offset = 70
      const currentScroll = window.scrollY
      let direction = 0

      if (!this.headerElement) {
        this.headerElement = document.getElementById('header')
      } else {
        if (currentScroll > this.previousScroll) {
          //scrolled up
          direction = 2
        } else if (currentScroll < this.previousScroll) {
          //scrolled down
          direction = 1
        }
        if (window) {
          if (direction === 1) {
            this.headerElement.classList.add('up')
            this.headerElement.classList.remove('down')
          }
          if (direction === 2) {
            this.headerElement.classList.add('down')
            this.headerElement.classList.remove('up')
          }
          if (window.scrollY > offset) {
            if (!this.headerElement.classList.contains('active')) {
              this.headerElement.classList.add('active')
            }
          } else {
            if (this.headerElement.classList.contains('active')) {
              this.headerElement.classList.remove('active')
            }
          }
        }
        this.previousScroll = currentScroll
      }
    }
  }

  render() {
    const { ui, blok, preview, path, locale } = this.props

    const { links }: any = blok && blok.content ? blok.content : {}
    const { activeMenu, setActiveMenu } = ui || {}

    return (
      <React.Fragment>
        <header
          className={[
            styles.wrapper,
            activeMenu === 'nav' ? styles.active : '',
          ].join(' ')}
        >
          <Container
            className={[styles.container, preview ? styles.preview : ''].join(
              ' '
            )}
            flexDirection="row"
            alignItems={'center'}
            justifyContent="space-between"
            id="header"
          >
            <Box />
            <Box
              aria-label="Menu Button"
              className={
                activeMenu === 'nav'
                  ? [styles.hamburger, styles.active, 'hideDesktop'].join(' ')
                  : [styles.hamburger, 'hideDesktop'].join(' ')
              }
              as="button"
              onClick={() => {
                if (activeMenu === 'nav') {
                  setActiveMenu('')
                } else {
                  setActiveMenu('nav')
                }
              }}
            >
              <div />
              <div />
            </Box>
            <Box className={[styles.navigation, 'hideMobile'].join(' ')}>
              {Object.keys(locales) && Object.keys(locales).length > 1 && (
                <Flex
                  className={styles.upperNavigation}
                  justifyContent="flex-end"
                  marginBottom={3}
                >
                  <Flex
                    className={styles.language}
                    alignItems="center"
                    justifyContent="center"
                  >
                    {Object.keys(locales).map((localeKey: string) => (
                      <LinkComponent
                        to={path}
                        lang={localeKey}
                        key={localeKey}
                        className={locale === localeKey ? styles.selected : ''}
                      >
                        <Box as="span">{locales[localeKey].title}</Box>
                      </LinkComponent>
                    ))}
                  </Flex>
                </Flex>
              )}
              <Flex justifyContent="flex-end">
                {links &&
                  links.length > 0 &&
                  links.map((link: any) => (
                    <LinkComponent
                      to={link.slug}
                      className={styles.link}
                      key={link._uid}
                    >
                      {link.title}
                    </LinkComponent>
                  ))}
              </Flex>
            </Box>
          </Container>
        </header>
        <MobileNav path={path} locale={locale} links={links} />
      </React.Fragment>
    )
  }
}

export default Header
